import React, { useRef } from 'react';
import { FaArrowRight } from 'react-icons/fa';

const experiences = [
  {
    title: 'Samsung Research Institute, Noida',
    date: 'May ’26 – Jul ’26',
    subtitle: 'R&D Intern | AI Team',
    paragraphs: [
      'Built an on-device document classification pipeline for Android, from synthetic data generation to a lightweight TFLite model with sub-80ms CPU inference and strong accuracy.',
      'Also improved Samsung Health’s LSTM deployment by cutting peak RAM usage by 80%, enabling more efficient on-device execution.',
    ],
  },
  {
    title: 'ULM Framework',
    date: '2025 – Present',
    subtitle: 'Research Assistant | MUSE Lab, IIT Gandhinagar',
    link: 'https://github.com/nikhil-405/DeepMotionTrack/tree/main',
    paragraphs: [
      'Worked on attention-based denoising and motion-guided assignment for robust microbubble tracking in ULM.',
      'Helped push vessel reconstruction quality to state-of-the-art levels even while operating at half the imaging rate.',
    ],
  },
  {
    title: 'Indic OCR',
    date: '2024 – 2025',
    subtitle: 'Research Assistant | Lingo Lab, IIT Gandhinagar',
    link: 'https://drive.google.com/drive/folders/1tU5Maypg5wYxv1PiJ34zuHa_OoLo1xbX?usp=sharing',
    paragraphs: [
      'Worked on OCR for Devanagari, including legacy non-Unicode fonts, using synthetic data to handle ligatures and conjuncts more effectively.',
      'Contributed to a language-agnostic design intended to extend the system to other Indic scripts in the future.',
    ],
  },
];

export default function Experiences() {
  const containerRef = useRef(null);

  return (
    <div className="projects-container">
      <div className="cards-wrapper" ref={containerRef}>
        <div className="scroll-spacer" />
        {experiences.map((exp) => {
          const cardContent = (
            <div className="card card-with-arrow">
              {exp.link && <FaArrowRight className="project-card-arrow" />}
              <h3>{exp.title}</h3>
              <p><em>{exp.date}</em></p>
              {exp.subtitle && <p><strong>{exp.subtitle}</strong></p>}
              {exp.paragraphs.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          );

          if (exp.link) {
            return (
              <a
                href={exp.link}
                target="_blank"
                rel="noopener noreferrer"
                className="card-link"
                key={exp.title}
              >
                {cardContent}
              </a>
            );
          }

          return (
            <div className="card-link" key={exp.title}>
              {cardContent}
            </div>
          );
        })}
        <div className="scroll-spacer" />
      </div>
    </div>
  );
}
